/**
 * Backfill guards for recurring donations.
 *
 * Confirmation is a UX check for a large but plausible history.
 * The hard limit rejects a malformed series instead of silently truncating.
 * 400 covers a weekly gift across the full 6 tax year recording window
 * (about 366 occurrences) and still stops an unbounded date.
 */
export const RECURRING_BACKFILL_CONFIRM_THRESHOLD = 36
export const RECURRING_BACKFILL_HARD_LIMIT = 400
